
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from 'react-hook-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faHome, faPlug, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Badge, Breadcrumb, Button, Card, Form, Table } from '@themesberg/react-bootstrap';
import { confirmDeleteToast, sendError, sendSuccess, status } from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { Avatar } from "@mui/material";
import { useApi, useHasPermission } from "../helpers/useApi";
import { Model } from "../components/Model";
import { SelectBox } from "../components/SelectBox";
import { Textbox } from "../components/Textbox";
import Permissions from "../Routes/permissions";

export const Users = () => {
  const callApi = useApi();
  const hasPermission = useHasPermission();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);



  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const [showModel, setShowModel] = useState(false);

  const [roles, setRoles] = useState([]);

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
    loadRoles();
  }, [])

  useEffect(() => {
    const delay = setTimeout(() => {
        if(isTyping){
          setIsTyping(false);
          getData(1);
        }
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);


  const handlePageChange = (newPage) => {
    getData(newPage);
  }

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`)
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? data.pageNo}`,
        `pageSize=${data.pageSize}`,
        `sortOrder=desc`
      ].filter(Boolean).join("&");

      const response = await callApi(API_URL_ENDPOINT.Users + `?${queryParams}`);
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({
        items: [],
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
        totalRecords: 0,
      });
    } finally {
      setDataLoading(false);
    }
  }

  const handleView = (id) => {
    // alert("Not Set")
    navigate(Routess.Company.path + `/${id}`)
  }

  const handleDelete = () => {
    confirmDeleteToast(() => {
      sendSuccess("Deleted successfully!");
    });
  };

  const submitForm = async (data) => {
    console.log("data", data)
    try {
      const payload = {
        "firstName": data.firstName,
        "lastName": data.lastName,
        "email": data.email,
        "phone": data.mobileNumber,
        "roleName": data.role
      };

      const response = await callApi(
        API_URL_ENDPOINT.Users,
        {
          method: "POST",
          data: payload,
        }
      );
      if (response.status) {
        setShowModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }

  }

  const loadRoles = async () => {
    try {
      // SuperAdmin, Branch, KYC, Support
      const excludedCategories = ['SuperAdmin', 'Branch'];
      const filters = `ExcludedRoleCategory:${excludedCategories.join(',')}`;
      const response = await callApi(
        `${API_URL_ENDPOINT.Users}/role-list?filters=${encodeURIComponent(filters)}`
      );
      if (response.status) {
        setRoles(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      setDataLoading(false);
    }
  }

  return (
    <>
      <Model show={showModel} size={"lg"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Employee</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submitForm)}>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="First Name"
                    name={"firstName"}
                    Placeholder="First Name"
                    validationRules={{ required: "First Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Last Name"
                    name={"lastName"}
                    Placeholder="Last Name"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="Role"
                    name={"role"}
                    validationRules={{ required: "Role is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""} selected>Select Role</option>
                    {roles?.map((item, index) => (
                      <option key={index} value={item.name}>{item.name}</option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Email"
                    name={"email"}
                    Placeholder="Email"
                    validationRules={{ required: "Email is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mobile Number"
                    name={"mobileNumber"}
                    Placeholder="Mobile Number"
                    validationRules={{ required: "Mobile Number is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>


      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>Employee</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Employee</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          {hasPermission(Permissions.Users.Create) && (
          <Button onClick={() => setShowModel(true)} className="me-2 d-block" variant="primary" style={{ whiteSpace: "nowrap" }}><FontAwesomeIcon icon={faPlus} /> Add New Employee</Button>
          )}
          <Form.Control value={searchTerm}onChange={(e) => { setSearchTerm(e.target.value); setIsTyping(true); }} type="text" className="shadow-none" placeholder={"Search..."} />
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="pb-0">
          {dataLoading ? (
            <div className="text-center my-3">
              <span className="spinner-border text-primary" role="status"></span>
            </div>
          ) : (
            <Table responsive className="table-centered table-nowrap rounded mb-0">
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Employee Name</th>
                  <th className="border-0 text-center">Role</th>
                  <th className="border-0 text-center">Phone Number</th>
                  <th className="border-0 text-center">Email</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.items?.length > 0 ? (
                  data?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(data.pageNo - 1) * data.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">{item.fullName || "-"}</td>
                      <td className="fw-bold align-middle text-center">{item.role || "-"}</td>
                      <td className="fw-bold align-middle text-center">{item.phoneNumber || "-"}</td>
                      <td className="fw-bold align-middle text-cemter">{item.email}</td>
                      <td className="text-end align-middle">
                        <Button variant="primary" className="btn-sm" onClick={() => handleView(item.id)}>View Details</Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination totalPages={data.totalPage} loading={dataLoading} onPageChange={handlePageChange} />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
